import { render, staticRenderFns } from "./AddChallengePartner.vue?vue&type=template&id=7f66e2fe&"
import script from "./AddChallengePartner.vue?vue&type=script&lang=js&"
export * from "./AddChallengePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f66e2fe')) {
      api.createRecord('7f66e2fe', component.options)
    } else {
      api.reload('7f66e2fe', component.options)
    }
    module.hot.accept("./AddChallengePartner.vue?vue&type=template&id=7f66e2fe&", function () {
      api.rerender('7f66e2fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/challenges/AddChallengePartner.vue"
export default component.exports